import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { KTSVG } from '../../../../_metronic/helpers'
import { useHistory } from 'react-router-dom'

import { Card, Button, Table, Modal, Spinner, Tooltip, OverlayTrigger } from 'react-bootstrap-v5'
import { GetAllInvoices, DeleteInvoice } from '../InvoiceService'

import { toast } from 'react-toastify'

import FullPageLoader from '../../FullPageLoader'
import { ErrorResponseModel } from '../../errors/models/ErrorResponseModel'
import { ErrorModel } from '../../errors/models/ErrorModel'
import { useAuth } from '../../../contexts/CustomContextHook/useAuth'
import useAxiosPrivate from '../../../contexts/CustomContextHook/useAxiosPrivate'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

interface InvoiceItem {
    quantity: string;
    description: string;
    unitPrice: number;
    lineTotal: number;
}

interface Invoice {
    id: number;
    invoiceNumber: number;
    customerName: string;
    invoiceDate: string;
    // invoiceDate: Date;
    items: InvoiceItem[];
}


const AllInvoice = () => {


    const history = useHistory();
    const {UserToken } = useAuth();

    const [loading, setLoading] = useState(true)

    const [hasErrors, setHasErrors] = useState('')

    const [invoice, SetInvoice] = useState<Invoice[]>([]);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const [showDeleteSpinner, SetshowDeleteSpinner] = useState(false);
    const [IdtoBDeleted, setIdtoBDeleted] = useState(0);

    const handleShow = (id: number) => {
        console.log('id in handleShow---', id);

        setShow(true);
        setIdtoBDeleted(id);

    };

    function handleDelete() {

        console.log('id in handle Delete---', IdtoBDeleted);

        SetshowDeleteSpinner(true);

        DeleteInvoice(axiosPrivate,IdtoBDeleted)
            .then((res : any) => {
                console.log('res from createSpace----', res);
                handleClose();
                SetshowDeleteSpinner(false);
                toast.warning('Invoice deleted successfully', { position: toast.POSITION.TOP_RIGHT });
                GetInvoice();
            })
            .catch((err : any) => {
                console.log('err from GetAllTypesNames', err);
                SetshowDeleteSpinner(false);
                toast.error('Error in deleting Invoice', { position: toast.POSITION.TOP_RIGHT });
            })
    };

    const axiosPrivate = useAxiosPrivate()
    const GetInvoice = () => {
        setLoading(true);

        GetAllInvoices(axiosPrivate)
            .then((res : any) => {
                console.log('res from getInvoices----', res);
                SetInvoice(res.data)
                setLoading(false);
            })
            .catch((err : any) => {
                setLoading(false);

                console.log('err from getInvoices', err);

                let Obj: ErrorResponseModel = err.toJSON();

                console.log(Obj.message);


                if (Obj.message === 'Network Error') {
                    setHasErrors('API Server is down....')
                }
                else {
                    let obj2: ErrorModel = JSON.parse(Obj.message);
                    setHasErrors(obj2.errorMessage);
                }

            })
    }

    useEffect(
        () => {
            GetInvoice()
        }, []
    )



    return (
        <>
            <div className="d-flex flex-wrap">
                <>

                    {/* --------------------------------------------------------------------------------- */}
                    <div className={'card mb-5 mb-xl-4 w-100 shadow-sm' }>


                        {/* begin::Header */}
                        <div className='card-header border-0 pt-5'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bolder fs-3 mb-1'>Invoices</span>
                                {/* <span className='text-muted mt-1 fw-bold fs-7'>All Offices in our PlatForm</span> */}
                            </h3>
                            {/* ---------------------- New / Edit --------------------- */}
                            {/* <div className='card-toolbar'>
                                <a className='btn btn-sm btn-light-primary'
                                    onClick={() => history.push('/menuItems/create')}
                                >
                                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                                    New
                                </a>
                            </div> */}
                            {/* ---------------------- New / Edit --------------------- */}
                        </div>
                        {/* end::Header */}
                        {/* begin::Body */}
                        <div className='card-body py-3'>
                            {/* begin::Table container */}
                            <div className='table-responsive'>
                                {hasErrors ? (
                                    <div className='mb-lg-15 alert alert-danger'>
                                        <div className='alert-text font-weight-bold'>{hasErrors}</div>
                                    </div>
                                ) : ''}

                                {loading &&
                                    <FullPageLoader />
                                }
                                {/* begin::Table */}

                                <table className='table align-middle gs-0 gy-4'>
                                <thead className='border border-1'>
                                    <tr className='fw-bolder w-250px text-muted bg-light'>
                                        <th className='ps-4 w-80px'>#</th>
                                        <th className='ps-4 w-150px'>Invoice Number</th>
                                        <th className='ps-4 w-150px'>Customer Name</th>
                                        <th className='ps-4 w-150px'>Invoice Date</th>
                                        <th className='ps-4 w-150px'>Invoice Items</th>
                                        <th className='w-100px'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoice.map((invoice, index) => (
                                        <tr key={invoice.id} className='border border-1'>
                                            <td className='ps-4 w-80px text-dark fw-bolder text-hover-primary'>
                                                {index + 1}
                                            </td>
                                            <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                                {invoice.invoiceNumber}
                                            </td>
                                            <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                                {invoice.customerName}
                                            </td>
                                            {/* <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                                {invoice.customerName}
                                            </td> */}
                                            <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                                {new Date(invoice.invoiceDate).toDateString()}
                                            </td>
                                            {/* <td>{format(invoice.invoiceDate, 'MM/dd/yyyy')}</td> Format the date for display */}

                                            <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                            <Popup trigger={<button className='btn btn-primary btn-sm'>Items</button>}>
                                                {invoice.items && invoice.items.length > 0 ? (
                                                    invoice.items.map((item, idx) => (
                                                        <div key={idx}>
                                                            <p>Quantity: {item.quantity}</p>
                                                            <p>Description: {item.description}</p>
                                                            <p>Unit Price: {item.unitPrice.toFixed(2)}</p>
                                                            <p>Line Total: {item.lineTotal.toFixed(2)}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span>No Items</span>
                                                )}
                                                </Popup>
                                            </td>
                                            {/* <td className='ps-4 w-150px text-dark fw-bolder text-hover-primary'>
                                                {format(invoice.invoiceDate, 'MM/dd/yyyy')}
                                            </td> */}
                                            <td className='ps-4 w-100px'>
                                                 <OverlayTrigger
                                                    delay={{ hide: 450, show: 300 }}
                                                    overlay={(props) => (
                                                        <Tooltip id={'tooltip-edit'} {...props}>
                                                            Edit Invoice
                                                        </Tooltip>
                                                    )}
                                                    placement="top"
                                                >
                                                    <a
                                                        className='btn btn-icon btn-bg-light mb-1 btn-active-color-warning btn-sm me-1'
                                                        onClick={() => history.push(`/menuItems/edit/${invoice.id}`)}
                                                    >
                                                        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                                    </a>
                                                </OverlayTrigger> 
                                                <OverlayTrigger
                                                    delay={{ hide: 450, show: 300 }}
                                                    overlay={(props) => (
                                                        <Tooltip id={'tooltip-delete'} {...props}>
                                                            Delete {invoice.invoiceNumber}
                                                        </Tooltip>
                                                    )}
                                                    placement="top"
                                                >
                                                    <a
                                                        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                        onClick={() => handleShow(invoice.id)}
                                                    >
                                                        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                                                    </a>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Delete Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>Are You sure to want to delete this MenuItem
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Cancel
                                        </Button>
                                        <Button variant="danger" onClick={handleDelete}>
                                            <div className='d-flex'>
                                                Delete
                                                {showDeleteSpinner && (
                                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )}
                                            </div>
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* end::Table */}
                            </div>
                            {/* end::Table container */}
                        </div>
                        {/* begin::Body */}
                    </div>
                    {/* ---------------------------------------------------------------- */}
                    {/* ---------------------------------------------------------------- */}

                </>

            </div >
        </>
    )
}


export { AllInvoice }